export default {"src":"/_next/static/media/check.f27d159f.svg","height":121,"width":121,"blurWidth":0,"blurHeight":0};